import * as PIXI from 'pixi.js';
import SystemConfig, {CONFIG_PARAMS} from "../../system/SystemConfig";
import ISymbols from "./ISymbols";
import {inject, injectable} from "inversify";
import SERVICE_IDENTIFIER from "../../constants/identifiers";
import PixiLayers from "./PixiLayers";
import Reels from "../../game/slot/Reels";

@injectable()
class PixiSymbols implements ISymbols {

    protected config: SystemConfig;
    protected layers: PixiLayers;

    constructor(
        @inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
        @inject(SERVICE_IDENTIFIER.EngineAppLayers) layers: PixiLayers
    ) {
        this.config = config;
        this.layers = layers;
    }

    /**
     * @param {number} index
     * @return {string|undefined}
     */
    getSymbolNameByIndex(index) {

        let symbolDefinition = this.config.get(CONFIG_PARAMS.SYMBOL_DEFINITION);

        if (!symbolDefinition[index]) {
            return;
        }

        return symbolDefinition[index]['name'];
    }

    /**
     * @param {number} index
     * @param {string} name
     * @param {PIXI.Container} layer
     * @param {boolean} blur
     * @return {PIXI.Sprite}
     */
    createByIndex(index, {name = null, blur = false }) {

        let symbolName = this.getSymbolNameByIndex(index);

        let textureName = blur ? symbolName + "_blur.png" : symbolName + ".png";

        let sprite = new PIXI.Sprite(PIXI.Texture.from(textureName));

        // @ts-ignore
        sprite.name = sprite.symbolName = symbolName;
        // sprite.textureName = textureName;

        // @ts-ignore
        sprite.symbolIndex = index;

        sprite.anchor.set(0.5, 0.5);
        return sprite;
    }

    createReelSymbol(index: number, {name = null, blur = false, reelX = null, reelY = null, x = null, y = null }) {

        let sprite = this.createByIndex(index, {name, blur});
        // @ts-ignore
        sprite.reelX = reelX; sprite.reelY = reelY;
        sprite.x = x != null ? x : -9999;
        sprite.y = y != null ? y : -9999;

        this.addToLayer(sprite);
        return sprite;
    }

    addToLayer(sprite, layer = this.layers.getLayer("reels")) {
        layer && layer.addChild(sprite);
    }

    /**
     * @param {Reels} reels
     * @return {Array<>}
     */
    createSpinSymbols(reels: Reels) {

        let reelsLen = reels.getReels().length;
        let spinSymbols = [];

        for(let i = 0; i < reelsLen; i++) {
            spinSymbols[i] = [];

            let symbols = this.config.get(CONFIG_PARAMS.REELS)[i];

            for(let j = 0; j < symbols.length; j++) {
                let index = symbols[j];
                let spinSymbol = this.createReelSymbol(index, {
                    name: `spin_${i}_${j}`,
                    blur: true,
                    reelX: i,
                });
                spinSymbol.visible = false;
                this.addToLayer(spinSymbol);
                spinSymbols[i].push(spinSymbol);
            }
        }

        return spinSymbols;
    }

    createResultSymbols(reelMatrix: [[]], blur = false, visible = true) {

        let symbols = [];
        for(let x = 0; x < reelMatrix.length; x++) {
            symbols[x] = [];
            for(let y = 0; y < reelMatrix[x].length; y++) {

                let index = reelMatrix[x][y];
                let symbol = this.createReelSymbol(index, {
                    name: `res_${x}_${y}`,
                    reelX: x,
                    reelY: y,
                    blur: blur
                });

                symbols[x][y] = symbol;
                symbol.visible = visible;
            }
        }

        return symbols;
    }
}

export default PixiSymbols;